try {
  window.$ = window.jQuery = require('jquery');
  window.bootstrap = require('bootstrap');
  require('jquery-lazy')
  require('parsleyjs');
} catch (e) {
}

Parsley.addMessages('de', {
  defaultMessage: 'Die Eingabe scheint nicht korrekt zu sein.',
  type:           {
    email:    'Die Eingabe muss eine gültige E-Mail-Adresse sein.',
    url:      'Die Eingabe muss eine gültige URL sein.',
    number:   'Die Eingabe muss eine Zahl sein.',
    integer:  'Die Eingabe muss eine Zahl sein.',
    digits:   'Die Eingabe darf nur Ziffern enthalten.',
    alphanum: 'Die Eingabe muss alphanumerisch sein.'
  },
  notblank:       'Die Eingabe darf nicht leer sein.',
  required:       'Dies ist ein Pflichtfeld.',
  pattern:        'Die Eingabe scheint ungültig zu sein.',
  min:            'Die Eingabe muss größer oder gleich %s sein.',
  max:            'Die Eingabe muss kleiner oder gleich %s sein.',
  range:          'Die Eingabe muss zwischen %s und %s liegen.',
  minlength:      'Es müssen min. %s Zeichen eingegeben werden.',
  maxlength:      'Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.',
  length:         'Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.',
  mincheck:       'Wählen Sie mindestens %s Angaben aus.',
  maxcheck:       'Wählen Sie maximal %s Angaben aus.',
  check:          'Wählen Sie zwischen %s und %s Angaben.',
  equalto:        'Dieses Feld muss dem anderen entsprechen.'
});

Parsley.addValidator('minwords', {
  requirementType: 'string',
  validateString:  function (value, nbWords) {
    return value.replace(/(^\s*)|(\s*$)/gi, "").replace(/\s+/gi, " ").split(' ').length >= nbWords;
  },
  messages:        {
    en: 'This value must contain at least %s words.',
    de: 'Die Eingabe muss min. %s Wörter enthalten.'
  }
});

Parsley.setLocale(locale);

jQuery(function ($) {
  $('.navbar-toggler').click(function () {
    $('#sidebarMenu, footer').toggleClass('expand');
    $('main').toggleClass('collapse');
  });

  $('form.parsley').parsley({
    errorClass:    'is-invalid state-invalid',
    successClass:  'is-valid state-valid',
    errorsWrapper: '<span class="invalid-feedback">',
    errorTemplate: '<div></div>',
    trigger:       'change keyup',
    excluded:      ':disabled'
  });

  $('#billing-address').change(function () {
    $('#billing').toggleClass('d-none').find(':input').prop('disabled', function (i, v) {
      return !v;
    });
  });

  $('.reservation-type').change(function () {
    if ($(this).val() == 'business') {
      $('#info-company').removeClass('d-none').find(':input').prop('disabled', false);
      $('#bank-transfer').removeClass('d-none');
    } else {
      $('#info-company').addClass('d-none').find(':input').prop('disabled', true);
      $('#bank-transfer').addClass('d-none');
      $('#cash').prop('checked', true).change();
    }
  });

  $('.payment-method').change(function () {
    $('.payment-info').addClass('d-none').find(':input').prop('disabled', true);
    $('#alert-' + $(this).val()).removeClass('d-none').find(':input').prop('disabled', false);
  });

  $('#company').bind('input', function () {
    $('#ph-company').html($(this).val());
  });

  $('#name').bind('input', function () {
    $('#ph-guest').html($(this).val());
  });
});
